import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  AuthorizeNetSavedPaymentMethod,
  PaymentsService,
} from 'src/app/services/payments.service';

@Component({
  selector: 'app-saved-payment-card',
  templateUrl: './saved-payment-card.component.html',
  styleUrl: './saved-payment-card.component.scss',
})
export class SavedPaymentCardComponent {
  @Input() paymentMethod!: AuthorizeNetSavedPaymentMethod;
  @Input() canManagePaymentMethods!: boolean;
  @Input() settingDefaultMethod = false;
  @Input() showAPIDefault = true;
  @Output() setDefault = new EventEmitter<AuthorizeNetSavedPaymentMethod>();
  @Output() setApiDefault = new EventEmitter<AuthorizeNetSavedPaymentMethod>();
  @Output() deleteMethod = new EventEmitter<AuthorizeNetSavedPaymentMethod>();

  constructor(private paymentsService: PaymentsService) {}

  bankAccountTypeLabel(method: AuthorizeNetSavedPaymentMethod) {
    return this.paymentsService.getBankAccountTypeLabel(
      method.bank_account_type ?? ''
    );
  }

  formattedAddress(method: AuthorizeNetSavedPaymentMethod) {
    let str = '';
    if (method.company) {
      str += `${method.company}<br>`;
    }

    if (method.first_name || method.last_name) {
      if (method.first_name) {
        str += `${method.first_name} `;
      }
      if (method.last_name) {
        str += `${method.last_name}`;
      }
      str += `<br>`;
    }

    if (method.address) {
      str += `${method.address}<br>`;
    }
    if (method.city || method.state || method.zip_code) {
      if (method.city) {
        str += `${method.city}, `;
      }
      if (method.state) {
        str += `${method.state} `;
      }
      if (method.zip_code) {
        str += `${method.zip_code}`;
      }
      str += `<br>`;
    }
    return str;
  }
}
